import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(4.69vw, 67px) min(13.93vw, 199px) min(1.89vw, 27px);
  align-items: center;
  background-color: #ffffff;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  .social-media-heading {
    font-size: min(3.85vw, 60px);
    line-height: min(3.78vw, 54px);
    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(3.08vw, 44px);
    text-align: center;
  }
  .social-media-sub-heading {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(3.08vw, 44px);
    color: #095587;
    text-align: center;
  }
  .social-media-image {
    width: min(72.87vw, 1041px);
    max-width: 100%;
    margin: 0 auto min(4.9vw, 70px);
  }
  @media (max-width: 767px) {
    padding: min(4.69vw, 67px);
    .social-media-image {
      width: 100%;
    }
    .social-media-heading {
      line-height: 4vw;
      margin-bottom: 2.42vw;
    }
    .social-media-sub-heading {
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
    }
  }
`;

export { Container, Wrapper };
